<template>
  <div>
    <div class="py-3">
      <v-icon :class="$style.starContentsListTitle">far fa-star</v-icon>
      <span :class="[$style.starContentsListTitle, 'title']">
        {{ lang.StarContentsList.title }}
      </span>
      <span
        v-if="isExistsStarContentsList"
        :class="[$style.starContentsListTitle, 'body-1']"
        data-star-contents-count
      >
        {{ starContentsCountText }}
      </span>
    </div>

    <div v-if="isExistsStarContentsList">
      <ul :class="$style.contentsListContainer">
        <li
          v-for="(starContents, index) in starContentsList"
          :key="index"
          :class="['pa-1', 'mb-2']"
          :style="contentsCardWidth"
        >
          <vc-share-contents-card
            :thumbnail-image-src="starContents.thumbnailImageUrl"
            :contents-title="starContents.title"
            :creator-name="starContents.clipUserHandle"
            :is-panel="starContents.isPanel"
            :contents-size="starContents.size"
            :publication-type="starContents.publicationType"
            :is-contents-sensitive="starContents.isSensitive"
            :contents-url="starContents.contentUrl"
            :contents-full-window-url="starContents.contentsFullWindowUrl"
            :lang="lang.ContentsCard"
            :is-webtoon="starContents.isVertical"
          >
            <v-btn
              small
              :class="$style.btnTextStyle"
              @click="releaseStarContents(starContents, index)"
            >
              <starIcon :class="$style.starIconColor"></starIcon>
              <span class="pl-1"> {{ lang.StarContentsList.release }} </span>
            </v-btn>
          </vc-share-contents-card>
        </li>
      </ul>
    </div>

    <v-container v-else fluid class="pt-3">
      <v-layout class="body-1 pl-3 pt-2">
        {{ lang.StarContentsList.nothing_star_contents }}
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ice from "../../../lib/ice";
import starIcon from "./assets/star_icon.svg";

export default {
  name: "vc-share-star-contents-list",
  components: {
    starIcon
  },
  props: {
    lang: {
      type: Object,
      default: () => {
        return {
          StarContentsList: {
            title: "お気に入り",
            release: "登録解除",
            confirm_release: "この作品を解除します。よろしいですか？",
            star_contents_release: "お気に入りを解除しました。",
            star_contents_count: "全 :contents_count 件",
            nothing_star_contents:
              "該当する作品がありません。「お気に入り」をクリックして登録しよう！",
            view_3d_button_text: "3D表示",
            view_3d_button_ON: "ON",
            view_3d_button_OFF: "OFF"
          },
          ContentsCard: {}
        };
      }
    },
    initialStarContentsList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    wallViewerUrl: {
      type: String,
      default: ""
    },
    maxBookContentsCount: {
      type: Number,
      default: 0
    },
    maxPanelContentsCount: {
      type: Number,
      default: 0
    },
    contentsCountText: {
      type: String,
      default: ""
    },

    // stateToProps
    starContentsList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    starContentsCount: {
      type: Number,
      default: 0
    },

    // gettersToProps
    getOnWallBookCount: {
      type: Number,
      default: 0
    },
    getOnWallPanelCount: {
      type: Number,
      default: 0
    },

    // actionsToProps
    deleteFromStarContentsList: {
      type: Function,
      default: () => {
        return {};
      }
    },
    deleteContentsOnWall: {
      type: Function,
      default: () => {}
    },

    // mutationsToProps
    updateStarContentsList: {
      type: Function,
      default: () => {
        return {};
      }
    }
  },
  data: function() {
    return {
      starContentsCountText: "",
      isExistsStarContentsList: true,
      isIce: false,
      isBookPostedLimit: false,
      isPanelPostedLimit: false,
      errorBookPostedLimitText: "",
      errorPanelPostedLimitText: ""
    };
  },
  mounted: function() {
    this.updateStarContentsList(this.initialStarContentsList);
    this.starContentsCountText = this.contentsCountText.replace(
      ":contents_count",
      this.initialStarContentsList.length + " "
    );
    this.errorBookPostedLimitText = this.lang.StarContentsList.error_book_posted_limit.replace(
      ":posted_limit_count",
      this.maxBookContentsCount
    );
    this.errorPanelPostedLimitText = this.lang.StarContentsList.error_panel_posted_limit.replace(
      ":posted_limit_count",
      this.maxPanelContentsCount
    );
    if (this.starContentsCount > 0) {
      this.isExistsStarContentsList = true;
    }
    this.isIce = ice.isIce();

    const bodyElement = document.getElementById("body");
    const thisObj = this;
    bodyElement.onblur = function() {
      const embededViewerIframeElement = document.querySelector(
        "[data-embeded-viewer]"
      ).contentWindow;
      embededViewerIframeElement.postMessage(
        "onBlurFired",
        thisObj.wallViewerUrl
      );
    };
  },
  methods: {
    releaseStarContents: function(contents, index) {
      if (!confirm(this.lang.StarContentsList.confirm_release)) {
        return;
      }

      this.deleteFromStarContentsList(contents.identificationCode).then(res => {
        if (res === 0) {
          if (contents.isOnWall) {
            this.deleteContentsOnWall(index);
          }
          alert(this.lang.StarContentsList.star_contents_release);
          const textElement = document.querySelector(
            "[data-star-contents-count]"
          );
          if (textElement) {
            this.starContentsCountText = this.contentsCountText.replace(
              ":contents_count",
              this.starContentsCount + " "
            );
            textElement.innerText = this.starContentsCountText;
          }
        }
      });
    }
  },
  computed: {
    contentsCardWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return { width: "100%" };
        case "sm":
          return { width: "50%" };
        case "md":
          return { width: "33%" };
        default:
          return { width: "25%" };
      }
    }
  },
  watch: {
    starContentsCount: function() {
      this.isExistsStarContentsList = this.starContentsCount > 0;
    },
    getOnWallBookCount() {
      this.isBookPostedLimit =
        this.getOnWallBookCount >= this.maxBookContentsCount;
      const onWallBookCountElements = document.querySelector(
        "[data-on-wall-book-number]"
      );
      if (onWallBookCountElements) {
        onWallBookCountElements.innerText = this.getOnWallBookCount;
      }
    },
    getOnWallPanelCount() {
      this.isPanelPostedLimit =
        this.getOnWallPanelCount >= this.maxPanelContentsCount;
      const onWallPanelCountElements = document.querySelector(
        "[data-on-wall-panel-number]"
      );
      if (onWallPanelCountElements) {
        onWallPanelCountElements.innerText = this.getOnWallPanelCount;
      }
    }
  }
};
</script>

<style module>
.btnTextStyle {
  text-transform: none !important;
  min-width: auto;
  padding: 2px 4px 2px 4px;
  font-size: 12px;
  height: auto;
  margin-right: 4px;
}

.contentsListContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: auto;
}

.starContentsListTitle {
  vertical-align: middle;
}

.starIconColor {
  fill: black;
}
</style>
